export default __webpack_public_path__ + "static/media/BacaOnline.5bbce2d9.png";